// TODO: move this to shared components
import { useEffect } from 'react';

/**
 * Prevents scrolling on the body element if `prevent` is true (default).
 */
export const usePreventBackgroundScroll = (prevent = true) => {
  useEffect(() => {
    if (!prevent) return;

    const bodyElement = document.querySelector('body');
    const { documentElement } = document;
    if (!bodyElement) return;

    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
    const previousOverflow = bodyElement.style.overflow;
    const previousPaddingRight = bodyElement.style.paddingRight;

    Object.assign(bodyElement.style, {
      overflow: 'hidden',
      paddingRight: scrollbarWidth > 0 ? `${scrollbarWidth}px` : previousPaddingRight,
    });

    return () => {
      Object.assign(bodyElement.style, { overflow: previousOverflow, paddingRight: previousPaddingRight });
    };
  }, [prevent]);
};
